import {createGlobalStyle} from 'styled-components'
import {isAndroid} from 'react-device-detect'

export const GlobalStyleAdmin = createGlobalStyle<{ $spMode: boolean }>`
  html {
    scroll-behavior: smooth;
  }

  ${props => !props.$spMode && isAndroid && `
  #pp-dialog {
    height: 100vh;
  }

  #pp-dialog .MuiDialog-paperScrollPaper {
    max-height: 100%;
  }
  `}
  ${props => props.$spMode && `
    .withErrorMessage {
      width : 100%;
    }
  `}
`
